// ABOUTME: Data for the Shareable Links page (DVLP-5753, gated by DVLP-7041): a
// ABOUTME: lightweight collection payload and the page's load state.
import { Maybe as StructuredMaybe } from '@execonline-inc/structured-maybe';
import { AlreadyTranslatedText } from '@execonline-inc/translations';
import { InvalidUrlError } from '@execonline-inc/url';
import { Maybe } from 'maybeasy';
import { AppyError } from '../../../../../Appy';
import { MissingLinkError } from '../../../../../LinkyLinky';
import { SearchParameters } from '../../../../../ListFilter/Types';
import { Resource } from '../../../../../Resource/Types';
import { OfferingType, ProgramFamilyShareUrlResource, ShareUrlResource } from '../../../Types';

export interface ShareableLinkExperience {
  id: number;
  offeringType: OfferingType;
  schoolPartnerLogoUrl: Maybe<string>;
  schoolPartnerName: Maybe<string>;
}

export interface ShareableLink {
  name: AlreadyTranslatedText;
  shareUrl: ProgramFamilyShareUrlResource;
  experience: Resource<ShareableLinkExperience>;
}

export interface ShareableLinksCollection {
  id: number;
  name: string;
  publishedAt: StructuredMaybe<Date>;
  shareUrl: StructuredMaybe<ShareUrlResource>;
  programFamilyShareUrls: ShareableLink[];
  possibleShareUrlCount: number;
  duplicateProgramDeepLinkCount: number;
  totalShareUrlCount: number;
  filteredShareUrlCount: number;
}

export type ShareableLinksResource = Resource<ShareableLinksCollection>;

export type ShareableLinksError = AppyError | MissingLinkError | InvalidUrlError;

export interface Loading {
  kind: 'loading';
  id: string;
  searchParameters: SearchParameters;
}

export interface Ready {
  kind: 'ready';
  id: string;
  resource: ShareableLinksResource;
  searchParameters: SearchParameters;
}

export interface Failed {
  kind: 'failed';
  id: string;
  error: ShareableLinksError;
  searchParameters: SearchParameters;
}

export type State = Loading | Ready | Failed;

export const loading = (id: string, searchParameters: SearchParameters): Loading => ({
  kind: 'loading',
  id,
  searchParameters,
});

export const ready = (state: Loading, resource: ShareableLinksResource): Ready => ({
  kind: 'ready',
  id: state.id,
  resource,
  searchParameters: state.searchParameters,
});

export const failed = (state: Loading, error: ShareableLinksError): Failed => ({
  kind: 'failed',
  id: state.id,
  error,
  searchParameters: state.searchParameters,
});
